import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import InputSenha from '../../../components/form/InputSenha';
import InputToken from '../../../components/form/InputToken';
import useFetch from '../../../components/hooks/useFetch';
import './esqueciSenha.css';

import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import { ALTERAR_SENHA, ENVIAR_TOKEN } from '../../../services/cadastro';

const RedefinirSenha = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { formRedefinirSenha } = createFormSchemas(t);
  const methods = useForm({ resolver: yupResolver(formRedefinirSenha) });

  const { request } = useFetch();
  const location = useLocation();
  const dados = location.state;
  const [modalAbertoToken, setModalAbertoToken] = useState(false);
  const idCorreios = dados[0];
  const ipAddress = dados[1];
  const meioEnvio = dados[2];
  const email = dados[3];
  const celular = dados[4];
  const [novaSenha, setNovaSenha] = useState();

  useEffect(() => {
    if (dados === null) {
      abreAlertaDialog(t('cadastro.messages.errors.access_denied'));
      navigate('/login');
    }
  }, [dados]);

  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  const alterar = async () => {
    const token1 =
      document.getElementById('confirmarSenha1').value +
      document.getElementById('confirmarSenha2').value +
      document.getElementById('confirmarSenha3').value +
      document.getElementById('confirmarSenha4').value +
      document.getElementById('confirmarSenha5').value +
      document.getElementById('confirmarSenha6').value;
    if (token1.length < 6) {
      abreAlertaDialog(t('cadastro.messages.validation.token_required'));
    } else {
      const senhaEnviar = {
        senha: novaSenha,
        token: token1,
      };
      const { response } = await request(
        ALTERAR_SENHA(idCorreios, senhaEnviar, ipAddress),
      );

      if (response.ok) {
        abreAlertaDialog(t('cadastro.messages.success.password_reset'));
        navigate('/login');
      }
    }
  };
  const fecharToken = (ev) => {
    ev.preventDefault();
    setModalAbertoToken(false);
  };
  const handleSubmit = async (data) => {
    setNovaSenha(data.novaSenha);
    var token;
    token = {
      meioEnvio: meioEnvio,
      funcionalidade: 'ESQUECEU_SENHA',
    };
    const { response } = await request(
      ENVIAR_TOKEN(idCorreios, token, ipAddress),
    );
    if (response.ok) {
      if (meioEnvio == 'E') {
        abreAlertaDialog(t('cadastro.messages.success.token_sent_email'));
      } else {
        abreAlertaDialog(t('cadastro.messages.success.token_sent_mobile'));
      }
      openModalToken();
    }
  };

  const openModalToken = () => {
    setModalAbertoToken(true);
  };
  const reenviaToken = async () => {
    const token = {
      meioEnvio: meioEnvio,
      funcionalidade: 'ESQUECEU_SENHA',
    };
    const { response } = await request(
      ENVIAR_TOKEN(idCorreios, token, ipAddress),
    );
    if (response.ok) {
      if (meioEnvio == 'E') {
        abreAlertaDialog(t('cadastro.messages.success.token_sent_email'));
      } else {
        abreAlertaDialog(t('cadastro.messages.success.token_sent_mobile'));
      }
      openModalToken();
    }
  };

  return (
    <>
      .
      {!modalAbertoToken ? (
        <div id="recuperar-senha" className="card bg-superficie elev5">
          <img
            alt="imagem de perfil da carol, assistente virtual dos correios"
            id="img-carol-boasvindas"
            src="/images/carol-perfil.png"
          />

          <h2>{t('cadastro.titles.reset_password')}</h2>

          <form
            id="formRedefinirSenha"
            onSubmit={methods.handleSubmit(handleSubmit)}
          >
            <div className="campo-txt">
              <InputSenha
                type="password"
                id="novaSenha"
                name="novaSenha"
                placeholder=""
                label={t('cadastro.forms.labels.new_password_detailed')}
                {...formMethods}
              />
              <InputSenha
                type="password"
                id="confirmaSenha"
                name="confirmaSenha"
                placeholder=""
                label={t('cadastro.forms.labels.confirm_password')}
                {...formMethods}
              />
            </div>

            <div className="btns-row">
              <button
                id="btn-voltar"
                type="button"
                className="btn-txt"
                onClick={() => navigate('/login')}
              >
                {t('cadastro.forms.buttons.back')}
              </button>

              <button id="btn-prosseguir" type="submit" className="btn-pre">
                {t('cadastro.forms.buttons.change_password')}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <form>
          <div id="finaliza-cadastro" className="conteudo">
            <div id="bem-vindo" className="card bg-superficie elev5">
              <img
                alt="Imagem de perfil da Carol"
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />

              <h2>{t('cadastro.titles.finalize_change')}</h2>

              <p className="txt-finalizacao">
                {t('cadastro.messages.info.finalize_change')}
              </p>
              <div className="campo-txt">
                <InputToken />
              </div>
              <div className="btns-row">
                <button
                  id="btn-reenviar"
                  type="button"
                  className="btn-cont"
                  onClick={reenviaToken}
                >
                  {t('cadastro.forms.buttons.resend_code')}
                </button>

                <button
                  id="btn-finalizar"
                  type="button"
                  className="btn-pre"
                  onClick={alterar}
                >
                  {t('cadastro.forms.buttons.complete')}
                </button>
                <button
                  className="btn-txt btn-fecha-dialog"
                  onClick={() => navigate('/login')}
                >
                  {t('cadastro.forms.buttons.cancel')}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
};
export default RedefinirSenha;
